import React from 'react';
import { Label } from '@patternfly/react-core';

const renderVmStatusLabel = (status: string | null) => {
  if (!status) return <Label color="grey">Unknown</Label>;
  switch (status.toLowerCase()) {
    case 'active':
      return <Label color="green">{status}</Label>;
    case 'offline':
      return <Label color="red">{status}</Label>;
    case 'planned':
      return <Label color="blue">{status}</Label>;
    case 'staged':
      return <Label color="orange">{status}</Label>;
    default:
      return <Label color="grey">{status}</Label>;
  }
};

export default renderVmStatusLabel;
